import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginDomainService } from './services/login/login.domain.service';
import { JobApiService } from './services/job/job.api.service';
import { JobDomainService } from './services/job/job.domain.service';
import { UserDomainService } from './services/user/user.domain.service';
import { UserApiService } from './services/user/user.api.service';
import { SpectrogramApiService } from './services/spectrogram/spectrogram.api.service';
import { SpectrogramDomainService } from './services/spectrogram/spectrogram.domain.service';
import { AdminApiService } from './services/admin/admin.api.service';
import { AdminDomainService } from './services/admin/admin.domain.service';
import { HistogramApiService } from './services/histogram/histogram.api.service';
import { HistogramDomainService } from './services/histogram/histogram.domain.service';
import { QuotaApiService } from './services/quota/quota.api.service';
import { QuotaDomainService } from './services/quota/quota.domain.service';
import { AlertApiService } from './services/alert/alert.api.service';
import { AlertDomainService } from './services/alert/alert.domain.service';
import { DashboardApiService } from './services/dashboard/dashboard.api.service';
import { DashboardDomainService } from './services/dashboard/dashboard.domain.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    LoginDomainService,
    JobApiService,
    JobDomainService,
    UserApiService,
    UserDomainService,
    SpectrogramApiService,
    SpectrogramDomainService,
    AdminApiService,
    AdminDomainService,
    HistogramApiService,
    HistogramDomainService,
    QuotaApiService,
    QuotaDomainService,
    AlertApiService,
    AlertDomainService,
    DashboardApiService,
    DashboardDomainService
  ],
  declarations: [],
  exports: []
})
export class DomainModule { }



// WEBPACK FOOTER //
// ./src/app/modules/domain/domain.module.ts